'use client'

import { matchPath, useLocation, useRoutes } from 'react-router-dom'
import { AppPath, appRoutes } from './routes/routes'
import { ThemeProvider } from 'react-jss'
import { useApp } from '@/hooks/useApp'
import useFaviconAndMeta from '@/hooks/useFaviconAndMeta'
import Layout from './components/Layout'
import { ErrorBoundary } from 'react-error-boundary'
import { InternalPage } from './feature/Error/pages/500'
import { useEffect } from 'react'
import { useJobPostingAdvancedSearchConditionBackup } from './hooks/useJobPostingAdvancedSearchConditionBackup'
import { scrollPositionKey } from './feature/Builder/Component/components/JobPostingCards/JobPostingCards'
import { currentPageKey } from './feature/Builder/Component/containers/JobPostingCardListContainer/JobPostingCardListContainer'
import { progressStatusFilterTypesKey } from './feature/JobPosting/pages/JobPostingProgressStatusPage'

export const Index = (): JSX.Element => {
  const element = useRoutes(appRoutes)
  const app = useApp()
  useFaviconAndMeta({ app })
  const location = useLocation()
  const [, updateConditionBackup] = useJobPostingAdvancedSearchConditionBackup()

  const isClearAdvancedSearchCondition =
    [AppPath.JobPostingAdvancedSearch, AppPath.JobPostingSearchResult].filter(
      (e, _) => {
        return matchPath({ path: e }, location.pathname)
      }
    ).length === 0

  const isClearCacheJobSearchPagination =
    [AppPath.JobPostingSearchResult, AppPath.JobPostingDetail].filter(
      (e, _) => {
        return matchPath({ path: e }, location.pathname)
      }
    ).length === 0

  const isClearCacheProgressStatusFilter =
    [AppPath.JobPostingProgressStatus, AppPath.JobPostingDetail].filter(
      (e, _) => {
        return matchPath({ path: e }, location.pathname)
      }
    ).length === 0

  const isClearCacheScrollPosition =
    [
      AppPath.JobPostingSearchResult,
      AppPath.JobPostingProgressStatus,
      AppPath.JobPostingDetail
    ].filter((e, _) => {
      return matchPath({ path: e }, location.pathname)
    }).length === 0

  useEffect(() => {
    if (isClearAdvancedSearchCondition) {
      updateConditionBackup(undefined)
    }

    if (isClearCacheJobSearchPagination) {
      sessionStorage.removeItem(currentPageKey)
    }

    if (isClearCacheProgressStatusFilter) {
      sessionStorage.removeItem(progressStatusFilterTypesKey)
    }

    if (isClearCacheScrollPosition) {
      sessionStorage.removeItem(scrollPositionKey)
    }
  }, [location.pathname])

  if (app.isLoading) return <></>

  return (
    <Layout>
      <ErrorBoundary key={location.pathname} fallbackRender={fallbackRender}>
        <ThemeProvider theme={app.theme}>{element}</ThemeProvider>
      </ErrorBoundary>
    </Layout>
  )
}

function fallbackRender({ error }: any): JSX.Element {
  return <InternalPage errorMessage={error.message} />
}
